import React from "react";
// Header

// Default
import { useState } from "react";
import { useNavigate } from "react-router-dom";

// Svg
import Vector from "../../assets/svg/vector";
import Notification from "../../assets/svg/notification";
import Question from "../../assets/svg/question";
import Setting from "../../assets/svg/setting";
import Ai from "../../assets/svg/ai";

// Image
import MaskGroup from "../../assets/images/Mask group.png";

// Mui
import Typography from "@mui/material/Typography";
import Stack from "@mui/material/Stack";
import Box from "@mui/material/Box";
import Avatar from "@mui/material/Avatar";
import IconButton from "@mui/material/IconButton";
import LogoutIcon from "@mui/icons-material/Logout";
import MoreVertIcon from "@mui/icons-material/MoreVert";

// Custom
import OutlinedButton from "../../forms/button/OutlinedButton";
import MeterHeader from "../meterCards/MeterHeader";
import ConsumerHeader from "../consumerCards/ConsumerHeader";
import ProPredictAI from "../PropredictAI/ProPredictAI";
import { resetStore } from "../../utils/helper";
import { Menu, MenuItem } from "@mui/material";

const Header = ({
  setSidebarOpen,
  title,
}: {
  setSidebarOpen: (value: boolean) => void;
  title: string;
}) => {
  const navigate = useNavigate();
  const [openAI, setOpenAI] = useState(false);
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleLogout = () => {
    resetStore();
  };

  return (
    <Box mb={"18px"}>
      <ProPredictAI openAI={openAI} setOpenAI={setOpenAI} />
      <Box className="header">
        <Stack
          className="header_first_stack"
          direction={"row"}
          alignItems={"center"}
          gap={"18px"}
        >
          {/* <IconButton onClick={() => setSidebarOpen(true)}>
            <Vector />
          </IconButton> */}
          {/* {window.location.pathname !== "/energy-performance-report" && (
            <div>
              <img src={MaskGroup} alt="Mask-Group" />
            </div>
          )} */}
          {window.location.pathname !== "/energy-performance-report" && (
            <Typography variant="h6" className="header_first_stack_title">
              {title}
            </Typography>
          )}
        </Stack>

        {window.location.pathname !== "/energy-performance-report" && (
          <Stack
            className="header_second_stack"
            flexDirection={"row"}
            alignItems={"center"}
            justifyContent={"center"}
          >
            <OutlinedButton
              label={
                <Stack direction={"row"} alignItems={"center"}>
                  <Typography variant="body1" mr={"10px"} color={"#1064ED"}>
                    <Ai />
                  </Typography>
                  <Typography
                    variant="caption"
                    fontWeight={700}
                    color={"#1064ED"}
                  >
                    ProPredict
                  </Typography>
                  <Typography
                    variant="caption"
                    fontWeight={400}
                    color={"#1064ED"}
                  >
                    &nbsp; AI Insights
                  </Typography>
                </Stack>
              }
              color={"#1064ED"}
              borderColor={"#1064ED"}
              bgColor={"#F6F7FB"}
              hoverBgColor={"#dce9ff"}
              onClick={() => setOpenAI(true)}
            />

            {/* <Stack ml={"40px"} mr={"34px"}>
            </Stack> */}

            <Stack
              direction={"row"}
              alignItems={"center"}
              gap={"20px"}
              ml={"30px"}
            >
              <Notification />
              {/* <IconButton onClick={handleLogout}>
                <LogoutIcon />
              </IconButton> */}
              <Question />
              {/* <Setting /> */}
              <div>
                <IconButton onClick={handleClick}>
                  <MoreVertIcon />
                </IconButton>
                <Menu
                  anchorEl={anchorEl}
                  open={open}
                  onClose={handleClose}
                  slotProps={{
                    list: {
                      "aria-labelledby": "basic-button",
                    },
                  }}
                >
                  <MenuItem onClick={handleClose}>Profile</MenuItem>
                  <MenuItem onClick={handleClose}>My account</MenuItem>
                  <MenuItem onClick={handleLogout}>Logout</MenuItem>
                </Menu>
              </div>
              <Stack
                direction={"row"}
                alignItems={"center"}
                className="header_second_stack_avatar"
              >
                {/* <Typography className="header_second_stack_avatar_title">
                Hi, Ram
              </Typography> */}
                <Avatar alt="Remy Sharp" />
              </Stack>
            </Stack>
          </Stack>
        )}
      </Box>
      <div>
        {(() => {
          switch (window.location.pathname) {
            // case "/meter-dashboard":
            //   return <MeterHeader />;
            case "/consumer-dashboard":
              return <ConsumerHeader />;
            default:
              return null;
          }
        })()}
      </div>
    </Box>
  );
};

export default Header;
